import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import useTranslate from '../../../i18n/useTranslate'

type Lookup = {
    id: number
    name_th: string
    name_en: string
}
export type OptType = {
    label: string
    value: string
}

type Resulttype = {
    id: number
    name_en: string
    name_th: string
}
type responseType = {
    message: string
    status: number
    result: Resulttype[]
}

const useIRBType = () => {
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const callApi = useCallApi()

    const [irbTypeList, setIRBTypeList] = useState<OptType[]>([])

    useEffect(() => {
        getLookup()
    }, [])

    const getLookup = async () => {
        try {
            const { data } = await callApi.axiosGet<responseType>({
                url: `${process.env.REACT_APP_CU_IRB_API_URL}/lookups/irbType`,
            })
            const lookup = data.result.map((itm) => {
                const container: OptType = {
                    ['label']: lang === 'en' ? itm.name_en : itm.name_th,
                    ['value']: itm.id.toString(),
                }

                return container
            })

            setIRBTypeList(lookup)
        } catch (error) {
            console.log('error', error)
        }
    }

    return { irbTypeList }
}

export default useIRBType
